import React, { useState } from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import CustomButton from 'Components/CustomButton/CustomButton'
import ComboBox from 'Components/ComboBox'
import { Input } from 'Components/Input'
import { useForm } from 'react-hook-form'
import { makePostRequest } from 'utils/api'

import { useMediaQuery, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)
export default function CreateOperationForm({ fetchOperations, jobList, typeactivite }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [open, setOpen] = useState(false)
  const [selectedType, setSelectedType] = useState(null)
  const [selectedJob, setSelectedJob] = useState(null)
  const {
    handleSubmit,
    control,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      date: '',
      activity_type: '',
      job_id: '',
      start_time: '',
      end_time: '',
      total_hours: '',
    },
  })

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    reset()
    setOpen(false)

    setSelectedJob(null)
    setSelectedType(null)
  }

  const onSubmit = async (data) => {
    let payload = { ...data, job_id: data.job_id.id, activity_type: data.activity_type.label }

    const response = await makePostRequest(
      '/api/Professional/workentrie-operations/',

      payload,
      {},
      true,
    )
    if (response.status === 201) {
      fetchOperations()
      handleClose()
    }
  }

  return (
    <>
      <CustomButton onClick={handleClickOpen}>{t('tempsTravail.btnAdd') /* LAP-733 (GE022) */}</CustomButton>

      <Dialog fullWidth maxWidth="xs" open={open} onClose={handleClose}>
        <DialogTitle sx={{ color: 'Black !important' }}>{t('tempsTravail.dialogTitle') /* LAP-733 (GE022) */}</DialogTitle>
        <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
          <DialogContent>
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                required: true,
                size: 'small',
                type: 'date',
              }}
              InputLabelProps={{ shrink: true }}
              rules={{ required: true }}
              name="date"
              label="Date"
            />
            <ComboBox
              handleAutoComplete={(e, j) => {
                setValue('activity_type', j)
                setSelectedType(j)
              }}
              label="Type d’activité"
              data={typeactivite}
              name="activity_type"
              required={true}
              selectedValue={selectedType}
            />
            <ComboBox
              handleAutoComplete={(e, j) => {
                setValue('job_id', j)
                setSelectedJob(j)
              }}
              label="Fonction"
              data={jobList}
              name="job_id"
              required={true}
              selectedValue={selectedJob}
            />

            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                // required: true,
                size: 'small',
                type: 'time',
              }}
              InputLabelProps={{ shrink: true }}
              // rules={{ required: true }}
              name="start_time"
              label="Heure de début "
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                // required: false,
                size: 'small',
                type: 'time',
              }}
              InputLabelProps={{ shrink: true }}
              // rules={{ required: false }}
              name="end_time"
              label="Heure de fin "
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                required: false,
                size: 'small',
                type: 'number',
              }}
              rules={{ required: false }}
              name="total_hours"
              label="Total in hours"
            />
          </DialogContent>
          <DialogActions>
            <Button type="submit">Valider</Button>
            <Button onClick={handleClose}>Annuler</Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}
